import extendNode from '../extendNode.mjs'
import useArCatNode from '../_AR_CAT/useArCatNode.jsx'
import meta from './metaAmarRs.mjs'

export default () => {
    const ArCatNode = useArCatNode()

    return extendNode(ArCatNode, {
        ...meta,

        canMountType(map, node, type) {
            return /^(AR|PIC|DOC)$/.test(type)
        },

        menuItemsInsertCommon(map, node) {
            return [
                {type: 'AR'},
                {type: 'PIC'},
                {type: 'DOC'},
            ]
        },
    })
}
